import { render, staticRenderFns } from "./ProfileCountriesDetails.vue?vue&type=template&id=6189e816&"
import script from "./ProfileCountriesDetails.vue?vue&type=script&lang=js&"
export * from "./ProfileCountriesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports